export default function HeaderV2({ }) {


    return (
        <div style={{ color: 'white' }}>Header V2</div>
    )
}